module.exports = __webpack_public_path__ + "assets/download-app-store.4c4985f6.svg";